// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/auth.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/auth.proto.
 */
export const file_api_gateway_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGkvZ2F0ZXdheS92MS9hdXRoLnByb3RvEgpnYXRld2F5LnYxIi8KDExvZ2luUmVxdWVzdBINCgVlbWFpbBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCSI8Cg1Mb2dpblJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJImMKIENvbXBsZXRlVGVtcG9yYXJ5UGFzc3dvcmRSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhoKEnRlbXBvcmFyeV9wYXNzd29yZBgCIAEoCRIUCgxuZXdfcGFzc3dvcmQYAyABKAkiUAohQ29tcGxldGVUZW1wb3JhcnlQYXNzd29yZFJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJIiYKDUxvZ291dFJlcXVlc3QSFQoNcmVmcmVzaF90b2tlbhgBIAEoCSIQCg5Mb2dvdXRSZXNwb25zZSIyCg9SZWdpc3RlclJlcXVlc3QSEAoIcGFzc3dvcmQYASABKAkSDQoFZW1haWwYAiABKAkiPwoQUmVnaXN0ZXJSZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkSFQoNcmVmcmVzaF90b2tlbhgCIAEoCSIiChFDaGVja1Rva2VuUmVxdWVzdBINCgV0b2tlbhgBIAEoCSI4ChJDaGVja1Rva2VuUmVzcG9uc2USEwoLdG9rZW5fdmFsaWQYASABKAgSDQoFZW1haWwYAiABKAkiLAoTUmVmcmVzaFRva2VuUmVxdWVzdBIVCg1yZWZyZXNoX3Rva2VuGAEgASgJIkMKFFJlZnJlc2hUb2tlblJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJIhAKDkdldFJvbGVSZXF1ZXN0IiAKD0dldFJvbGVSZXNwb25zZRINCgVyb2xlcxgBIAMoCTK7BAoVQXV0aGVudGljYXRpb25TZXJ2aWNlEjwKBUxvZ2luEhguZ2F0ZXdheS52MS5Mb2dpblJlcXVlc3QaGS5nYXRld2F5LnYxLkxvZ2luUmVzcG9uc2USeAoZQ29tcGxldGVUZW1wb3JhcnlQYXNzd29yZBIsLmdhdGV3YXkudjEuQ29tcGxldGVUZW1wb3JhcnlQYXNzd29yZFJlcXVlc3QaLS5nYXRld2F5LnYxLkNvbXBsZXRlVGVtcG9yYXJ5UGFzc3dvcmRSZXNwb25zZRI/CgZMb2dvdXQSGS5nYXRld2F5LnYxLkxvZ291dFJlcXVlc3QaGi5nYXRld2F5LnYxLkxvZ291dFJlc3BvbnNlEkUKCFJlZ2lzdGVyEhsuZ2F0ZXdheS52MS5SZWdpc3RlclJlcXVlc3QaHC5nYXRld2F5LnYxLlJlZ2lzdGVyUmVzcG9uc2USSwoKQ2hlY2tUb2tlbhIdLmdhdGV3YXkudjEuQ2hlY2tUb2tlblJlcXVlc3QaHi5nYXRld2F5LnYxLkNoZWNrVG9rZW5SZXNwb25zZRJRCgxSZWZyZXNoVG9rZW4SHy5nYXRld2F5LnYxLlJlZnJlc2hUb2tlblJlcXVlc3QaIC5nYXRld2F5LnYxLlJlZnJlc2hUb2tlblJlc3BvbnNlEkIKB0dldFJvbGUSGi5nYXRld2F5LnYxLkdldFJvbGVSZXF1ZXN0GhsuZ2F0ZXdheS52MS5HZXRSb2xlUmVzcG9uc2VCZAoOY29tLmdhdGV3YXkudjFCCUF1dGhQcm90b1ABogIDR1hYqgIKR2F0ZXdheS5WMcoCCkdhdGV3YXlcVjHiAhZHYXRld2F5XFYxXEdQQk1ldGFkYXRh6gILR2F0ZXdheTo6VjFiBnByb3RvMw");

/**
 * LoginRequest is the request message for authenticating a user.
 *
 * @generated from message gateway.v1.LoginRequest
 */
export type LoginRequest = Message<"gateway.v1.LoginRequest"> & {
  /**
   * email is the user's email address used as login identifier.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * password is the user's password.
   *
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message gateway.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 0);

/**
 * LoginResponse is the response message for the Login RPC.
 *
 * @generated from message gateway.v1.LoginResponse
 */
export type LoginResponse = Message<"gateway.v1.LoginResponse"> & {
  /**
   * access_token is the JWT access token for authenticating subsequent requests.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the token used to obtain a new access token when the current one expires.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 1);

/**
 * CompleteTemporaryPasswordRequest is the request message for replacing a temporary password.
 *
 * @generated from message gateway.v1.CompleteTemporaryPasswordRequest
 */
export type CompleteTemporaryPasswordRequest = Message<"gateway.v1.CompleteTemporaryPasswordRequest"> & {
  /**
   * email is the user's email address used as login identifier.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * temporary_password is the current temporary password issued to the user.
   *
   * @generated from field: string temporary_password = 2;
   */
  temporaryPassword: string;

  /**
   * new_password is the permanent password to set for the user.
   *
   * @generated from field: string new_password = 3;
   */
  newPassword: string;
};

/**
 * Describes the message gateway.v1.CompleteTemporaryPasswordRequest.
 * Use `create(CompleteTemporaryPasswordRequestSchema)` to create a new message.
 */
export const CompleteTemporaryPasswordRequestSchema: GenMessage<CompleteTemporaryPasswordRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 2);

/**
 * CompleteTemporaryPasswordResponse is the response message for the CompleteTemporaryPassword RPC.
 *
 * @generated from message gateway.v1.CompleteTemporaryPasswordResponse
 */
export type CompleteTemporaryPasswordResponse = Message<"gateway.v1.CompleteTemporaryPasswordResponse"> & {
  /**
   * access_token is the JWT access token for authenticating subsequent requests.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the token used to obtain a new access token when the current one expires.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.CompleteTemporaryPasswordResponse.
 * Use `create(CompleteTemporaryPasswordResponseSchema)` to create a new message.
 */
export const CompleteTemporaryPasswordResponseSchema: GenMessage<CompleteTemporaryPasswordResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 3);

/**
 * LogoutRequest is the request message for ending a user's session.
 *
 * @generated from message gateway.v1.LogoutRequest
 */
export type LogoutRequest = Message<"gateway.v1.LogoutRequest"> & {
  /**
   * refresh_token is the refresh token to invalidate.
   *
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 4);

/**
 * LogoutResponse is the response message for the Logout RPC.
 *
 * @generated from message gateway.v1.LogoutResponse
 */
export type LogoutResponse = Message<"gateway.v1.LogoutResponse"> & {
};

/**
 * Describes the message gateway.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 5);

/**
 * RegisterRequest is the request message for creating a new user account.
 *
 * @generated from message gateway.v1.RegisterRequest
 */
export type RegisterRequest = Message<"gateway.v1.RegisterRequest"> & {
  /**
   * password is the password for the new account.
   *
   * @generated from field: string password = 1;
   */
  password: string;

  /**
   * email is the email address for the new account.
   *
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message gateway.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 6);

/**
 * RegisterResponse is the response message for the Register RPC.
 *
 * @generated from message gateway.v1.RegisterResponse
 */
export type RegisterResponse = Message<"gateway.v1.RegisterResponse"> & {
  /**
   * access_token is the JWT access token for the newly created account.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the refresh token for the newly created account.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 7);

/**
 * CheckTokenRequest is the request message for validating a token.
 *
 * @generated from message gateway.v1.CheckTokenRequest
 */
export type CheckTokenRequest = Message<"gateway.v1.CheckTokenRequest"> & {
  /**
   * token is the JWT token to validate.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gateway.v1.CheckTokenRequest.
 * Use `create(CheckTokenRequestSchema)` to create a new message.
 */
export const CheckTokenRequestSchema: GenMessage<CheckTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 8);

/**
 * CheckTokenResponse is the response message for the CheckToken RPC.
 *
 * @generated from message gateway.v1.CheckTokenResponse
 */
export type CheckTokenResponse = Message<"gateway.v1.CheckTokenResponse"> & {
  /**
   * token_valid indicates whether the provided token is valid.
   *
   * @generated from field: bool token_valid = 1;
   */
  tokenValid: boolean;

  /**
   * email is the email address associated with the token's user.
   *
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message gateway.v1.CheckTokenResponse.
 * Use `create(CheckTokenResponseSchema)` to create a new message.
 */
export const CheckTokenResponseSchema: GenMessage<CheckTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 9);

/**
 * RefreshTokenRequest is the request message for refreshing an access token.
 *
 * @generated from message gateway.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"gateway.v1.RefreshTokenRequest"> & {
  /**
   * refresh_token is the current refresh token to exchange.
   *
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 10);

/**
 * RefreshTokenResponse is the response message for the RefreshToken RPC.
 *
 * @generated from message gateway.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"gateway.v1.RefreshTokenResponse"> & {
  /**
   * access_token is the new JWT access token.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the new refresh token.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 11);

/**
 * GetRoleRequest is the request message for retrieving the role of a user.
 *
 * @generated from message gateway.v1.GetRoleRequest
 */
export type GetRoleRequest = Message<"gateway.v1.GetRoleRequest"> & {
};

/**
 * Describes the message gateway.v1.GetRoleRequest.
 * Use `create(GetRoleRequestSchema)` to create a new message.
 */
export const GetRoleRequestSchema: GenMessage<GetRoleRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 12);

/**
 * GetRoleResponse is the response message for the GetRole RPC.
 *
 * @generated from message gateway.v1.GetRoleResponse
 */
export type GetRoleResponse = Message<"gateway.v1.GetRoleResponse"> & {
  /**
   * roles is the list of roles associated with the user of the provided token.
   *
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];
};

/**
 * Describes the message gateway.v1.GetRoleResponse.
 * Use `create(GetRoleResponseSchema)` to create a new message.
 */
export const GetRoleResponseSchema: GenMessage<GetRoleResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_auth, 13);

/**
 * AuthenticationService defines the gRPC service for managing authentication.
 *
 * -------------------------------------------------------------------------
 * Authentication operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.AuthenticationService
 */
export const AuthenticationService: GenService<{
  /**
   * Login authenticates a user with their credentials and returns access and refresh tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * CompleteTemporaryPassword verifies a temporary password, sets a permanent one, and returns tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.CompleteTemporaryPassword
   */
  completeTemporaryPassword: {
    methodKind: "unary";
    input: typeof CompleteTemporaryPasswordRequestSchema;
    output: typeof CompleteTemporaryPasswordResponseSchema;
  },
  /**
   * Logout invalidates the provided refresh token, ending the user's session.
   *
   * @generated from rpc gateway.v1.AuthenticationService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * Register creates a new user account and returns access and refresh tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * CheckToken validates a token and returns the associated user information if valid.
   *
   * @generated from rpc gateway.v1.AuthenticationService.CheckToken
   */
  checkToken: {
    methodKind: "unary";
    input: typeof CheckTokenRequestSchema;
    output: typeof CheckTokenResponseSchema;
  },
  /**
   * RefreshToken exchanges a valid refresh token for a new pair of access and refresh tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * GetRole retrieves the role of the user associated with the provided token.
   *
   * @generated from rpc gateway.v1.AuthenticationService.GetRole
   */
  getRole: {
    methodKind: "unary";
    input: typeof GetRoleRequestSchema;
    output: typeof GetRoleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_auth, 0);

